







































export default {
  props: {
    numberOfAdults: { type: Number, default: null },
    numberOfChildren: { type: Number, default: null },
    overCapacity: { type: Boolean, default: false },
    remainingSeats: { type: Number, default: null },
    missingSelections: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
  },
  emits: ['adultSeatsChange', 'childSeatsChange'],
  data() {
    return {
      isMissingNumberOfParticipants: false,
      hasNumberOfParticipantsChanged: false,
    };
  },
  computed: {
    participantSlots() {
      return Array.from(Array(21).keys());
    },
  },
  methods: {
    handleAdultSeatsChange(value) {
      this.$emit('adultSeatsChange', value);
    },
    handleChildSeatsChange(value) {
      this.$emit('childSeatsChange', value);
    },
  },
};
